import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import { HomePage } from './pages/homePage/index';
import { About } from './pages/about';
import { Dukaan } from './pages/work/dukaan';
import { Pathology } from './pages/work/pathology';
import { ChaiMoh } from './pages/work/chaimoh';
import { LiveFeed } from './pages/work/livefeed';
import { PageNotFound } from './pages/error/index';


function App() {
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
  }, []);

  return (
    <Router>
      <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/work/dukaan" element={<Dukaan />} />
            <Route path="/work/digitalpathology" element={<Pathology />} />
            <Route path="/work/chaimoh" element={<ChaiMoh />} />
            <Route path="/work/livefeed" element={<LiveFeed />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          <Analytics />
          <SpeedInsights />
      </div>
    </Router>
  );
}

export default App;